import { Form } from "@circle-react-uikit/Form";
import { Modal } from "@circle-react-uikit/ModalV2";
import type { ReactNode, RefObject } from "react";

import { t } from "@/i18n-js/instance";
// eslint-disable-next-line no-restricted-imports -- Preserve the legacy modal's button variants; this change only enables email links.
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { LinkInput } from "../../Form/LinkInput";

export function AddLinkFormBody({
  inputRef,
  submitButtonVariant = "primary",
  children,
}: {
  inputRef: RefObject<HTMLInputElement | null>;
  submitButtonVariant?: "primary" | "circle";
  children: ReactNode;
}) {
  return (
    <>
      <Modal.Body>
        <Form.Item
          hideDescription
          hideBorder
          fullWidth
          name="url"
          label={t("tiptap.extensions.link.link")}
        >
          <LinkInput name="url" ref={inputRef} allowMailTo />
        </Form.Item>
      </Modal.Body>
      <Modal.Footer className="px-5 md:px-8">
        <Button full type="submit" variant={submitButtonVariant}>
          {t("tiptap.extensions.link.save")}
        </Button>

        {children}
      </Modal.Footer>
    </>
  );
}
